import * as React from "react";
import { Form } from "informedv1";
import { TextBox } from "../../forms/TextBox";
import { Required } from "../../forms/validation/Required";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import AsyncActionButton from "../../misc/components/AsyncActionButton";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

export interface CredentialsFormProps {
    onComplete: (form) => void;
    onCancel: () => void;
}

export const CredentialsForm = (props: CredentialsFormProps) => {
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const legacyClient = useWebPortalLegacyClient();

    const onSubmit = async form => {
        setIsError(false);
        setIsSubmitting(true);
        const connectionTest = await legacyClient.testReportServerConnection(form.ServerAddress, form.Username, form.Password);

        setIsSubmitting(false);

        if (connectionTest) {
            props.onComplete(form);
        } else {
            setIsError(true);
        }
    };

    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-12">
                    <Alert show={isError} category={AlertCategoryEnum.Danger}>
                        Cannot connect to the server. Please check the connection details.
                    </Alert>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group row">
                        <div className="col-sm-4">
                            <label htmlFor="ServerURL" className="pull-right">Report Server Location</label>
                        </div>
                        <div className="col-sm-8">
                            <p>Enter the URL of the report server to connect to, avoid specifing a specific directory such as /Reports or /ReportServer</p>
                            <TextBox
                                id="ServerURL"
                                field="ServerAddress"
                                placeholder="http(s)://host.local"
                                validate={Required}
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-4">
                            <label htmlFor="Username" className="pull-right">Username</label>
                        </div>
                        <div className="col-sm-8">
                            <p></p>
                            <TextBox
                                id="Username"
                                field="Username"
                                validate={Required}
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-4">
                            <label htmlFor="Password" className="pull-right">Password</label>
                        </div>
                        <div className="col-sm-8">
                            <p></p>
                            <TextBox
                                id="Password"
                                field="Password"
                                type="password"
                                validate={Required}
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-12">
                            <div className="pull-right">
                                <AsyncActionButton className="btn btn-primary" type="submit" isSubmitting={isSubmitting}>
                                    <i className="fa fa-plug"></i> Connect to Server
                            </AsyncActionButton>
                                &nbsp;
                            <button className="btn btn-primary btn-outline" type="submit" disabled={isSubmitting} onClick={props.onCancel}>
                                    Cancel
                            </button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </Form>
    );
}
